import React from 'react';
import { Box, FormLabel, MenuItem, TextField, TextFieldProps } from '@mui/material';
import { getLocalizedProperty } from '@loyalty/shared-common';
import { useTranslation } from 'react-i18next';
import { CurrencyImage } from '../../shared/currency/CurrencyImage';
import { useCurrencies } from '../CurrenciesContext';

export function CurrencyDropdown({
  disabled,
  showLabel = false,
  ...props
}: TextFieldProps & { showLabel?: boolean; fullWidth?: boolean }) {
  const { currencies } = useCurrencies();
  const { t, i18n } = useTranslation();

  return (
    <>
      {showLabel && (
        <FormLabel id="currency.label.id">{t('levels.inputs.currency.label')}</FormLabel>
      )}
      <TextField select {...props} disabled={disabled} id="currency-id">
        {currencies.map(currency => (
          <MenuItem value={currency.id} key={currency.id} disabled={!!currency.deletedAt}>
            <Box display="flex" alignItems="center">
              <CurrencyImage currency={currency} style={{ margin: '-6px' }} />
              <Box
                ml={1}
                style={{ color: currency.deletedAt ? 'grey' : undefined }}
                id={`currency_${getLocalizedProperty(currency, 'name', i18n.language)}_id`}
              >
                {getLocalizedProperty(currency, 'name', i18n.language)}
              </Box>
            </Box>
          </MenuItem>
        ))}
      </TextField>
    </>
  );
}
